"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeResource = exports.StorefrontResource = void 0;
/** The restaurant's storefront: public info, and its settings for staff. */
class StorefrontResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /** Public — name, colours, contact and the checkout's payment options. */
    info() {
        return this.http.get('storefront', { skipAuth: true });
    }
    settings() {
        return this.http.get('storefront/settings');
    }
    updateSettings(payload) {
        return this.http.patch('storefront/settings', payload);
    }
    /* ------------------------- Recommendations ------------------------ */
    recommendations(placement) {
        return this.http.get('recommendations', { query: { placement } });
    }
    /** Replaces one list in full — its order is the content being edited. */
    saveRecommendations(payload) {
        return this.http.put('recommendations', payload);
    }
    /* ---------------------------- Campaigns --------------------------- */
    campaigns(query) {
        return this.http.getPaginated('marketing/campaigns', { query });
    }
    campaignAudience() {
        return this.http.get('marketing/campaigns/audience');
    }
    sendCampaign(payload) {
        return this.http.post('marketing/campaigns', payload);
    }
}
exports.StorefrontResource = StorefrontResource;
/**
 * The signed-in storefront customer (Mini App).
 *
 * No method takes a customer or account id: the server reads who is asking
 * from the session, and only from there.
 */
class MeResource {
    http;
    constructor(http) {
        this.http = http;
    }
    profile() {
        return this.http.get('me/profile');
    }
    updateProfile(payload) {
        return this.http.patch('me/profile', payload);
    }
    addresses() {
        return this.http.get('me/addresses');
    }
    createAddress(payload) {
        return this.http.post('me/addresses', payload);
    }
    updateAddress(id, payload) {
        return this.http.patch(`me/addresses/${id}`, payload);
    }
    deleteAddress(id) {
        return this.http.delete(`me/addresses/${id}`);
    }
    favorites() {
        return this.http.get('me/favorites');
    }
    addFavorite(productId) {
        return this.http.put(`me/favorites/${productId}`);
    }
    removeFavorite(productId) {
        return this.http.delete(`me/favorites/${productId}`);
    }
    orders(query) {
        return this.http.getPaginated('me/orders', { query });
    }
    order(id) {
        return this.http.get(`me/orders/${id}`);
    }
    /** Re-opens the payment page for an unpaid online order. Never a new order. */
    retryPayment(id, returnUrl) {
        return this.http.post(`me/orders/${id}/pay`, returnUrl ? { returnUrl } : {});
    }
    /** Asks the server to read the real status back from the payment provider. */
    refreshPayment(id) {
        return this.http.post(`me/orders/${id}/payment-status`);
    }
    promoCodes() {
        return this.http.get('me/promo-codes');
    }
    previewCheckout(payload) {
        return this.http.post('me/checkout/preview', payload);
    }
    /**
     * Places the order. `clientUuid` must be generated before the first
     * attempt and reused on every retry — it is also sent as the idempotency
     * key, so a lost response cannot become a second order.
     */
    checkout(payload) {
        return this.http.post('me/checkout', payload, {
            idempotencyKey: payload.clientUuid,
            // Payment providers can be slow to open a session.
            timeoutMs: 40_000,
        });
    }
    notifications(query) {
        return this.http.getPaginated('me/notifications', { query });
    }
    unreadCount() {
        return this.http.get('me/notifications/unread-count');
    }
    markNotificationsRead(ids) {
        return this.http.post('me/notifications/read', ids ? { ids } : {});
    }
    reverseGeocode(latitude, longitude) {
        return this.http.get('me/geo/reverse', { query: { lat: latitude, lng: longitude } });
    }
    searchPlaces(query, near) {
        return this.http.get('me/geo/search', {
            query: { q: query, lat: near?.latitude, lng: near?.longitude },
        });
    }
}
exports.MeResource = MeResource;
//# sourceMappingURL=storefront.js.map